import React from "react";
import {useTranslation} from "react-i18next";

function TranslationSwitch(props) {
    const {i18n} = useTranslation();
    const availableLanguages = [
        {
            key: 'ua',
            value: 'Українська',
            pic: "🇺🇦"
        },
        {
            key: 'en',
            value: 'English',
            pic: "🇺🇸"
        }
    ]

    function resolveLanguage(event) {
        i18n.changeLanguage(event.target.value).then()
    }

    return (
        <div style={{right: "10px"}}>
            <select value={i18n.language}
                    style={{backgroundColor: "unset", border: "unset",cursor: "pointer"}}
                    onChange={(e) => resolveLanguage(e)}>
                {availableLanguages.map((lang) => {
                    return <option key={lang.key} value={lang.key}>{lang.pic}</option>
                })}
            </select>
        </div>
    )
}

export default TranslationSwitch;